import { mdiAccountCardDetails, mdiCommentMultiple } from "@mdi/js";
import { MenuListItem, IMenuList } from "../../../model";

export enum siteMenuItemCategories {
  General = "General",
  Comments = "Comments"
}

/**  Class created to define the site menu container implementing the IMenuList interface */
export class SiteMenuContainer implements IMenuList {
  // This will be the interface structure used for the component to make it generic
  public menuItems: MenuListItem[];

  public constructor() {
    this.menuItems = this.getMenu();
  }

  public getMenu() {
    const menuList = [
      new MenuListItem(
        "General Info",
        mdiAccountCardDetails,
        "/site/:id",
        siteMenuItemCategories.General
      ),
      new MenuListItem(
        "Comments",
        mdiCommentMultiple,
        "/site/:id/comment",
        siteMenuItemCategories.Comments
      )
    ];

    return menuList;
  }
}
